<template>
  <Grid
    class="loc-pickup-grid"
    :data-items="items"
    :columns="columns"
    data-cy="loc-pickup-grid"
  >
    <template v-slot:DownloadCell="{ props: { dataItem, field } }">
      <td class="k-table-td">
        <a
          v-if="dataItem[field]"
          class="is-download-link"
          @click="downloadLoc(dataItem[field])"
          ><font-awesome-icon icon="fa-solid fa-arrow-down" />
          {{ dataItem.ZipFileDisplayName ?? "LOC" }}</a
        >
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { Grid } from "@progress/kendo-vue-grid";
import { ref } from "vue";
import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type { DateLetterHeaderAndCount } from "@/Domain/DateLetterHeaderAndCount";
import { api } from "@/api";
import { useMainStore } from "@/stores/useMainStore";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import { useNotificationStore } from "@/stores/useNotificationStore";

defineProps<{
  items: DateLetterHeaderAndCount[];
}>();

const main = useMainStore();
const notificationStore = useNotificationStore();

const columns = ref<GridColumnPropsExtended[]>([
  {
    title: "Requested",
    field: "Date",
    // type: "date",
    // format: "{0:MM/dd/yyyy h:mm a}",
  },
  {
    title: "Product Count",
    field: "Count",
  },
  {
    title: "Header",
    field: "LetterHeader",
  },
  {
    title: "Download",
    field: "Key",
    cell: "DownloadCell",
  },
]);

const downloadLoc = (key: string) => {
  return handleResponsePromiseAsync(
    api.get("GetLocPickupUrl", {
      companyLogin: main.companyLogin,
      locPickupKey: key,
    }),
    (url) => {
      if (url) window.location.assign(url);
    },
    "LocPickupGrid.vue",
    "downloadLoc",
    () => {
      notificationStore.notify({
        message: "Error downloading LOC. Please try again.",
        type: NotificationTypeEnum.error,
        duration: 5000,
      });
    }
  );
};
</script>

<style scoped lang="scss">
.k-grid {
  a.is-download-link {
    cursor: pointer;

    svg {
      height: 12px;
    }
    &:before {
      content: "";
    }
  }
}
</style>
